export default __webpack_public_path__ + "static/media/hkgcsmeaa.35154c3d.png";